export default {
  getChecklistItem: (state) => state.checklistItem,
};
